import React from 'react';

const NotFoundPage = () => (
  <div className="container is-fluid">
    <article className="tile is-child" style={{ paddingTop: '10rem' }}>
      <p className="home-title has-text-centered" style={{ marginBottom: '2rem' }}>NOT FOUND</p>
      <p className="subtitle has-text-centered is-size-4 m-text-white">
        You just hit a route that doesn&#39;t exist... the sadness.
      </p>
    </article>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js